import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const CircularProgressBar = ({
  value = 0,
  size = 50,          // ✅ default size (both width & height)
  thickness = 4.5,     // ✅ default thickness of stroke
  color = "#00a651",   // ✅ default stroke color
  bgColor = "#f1f1f1", // ✅ default background circle color
}) => {
  return (
    <Box
      position="relative"
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      width={size}
      height={size}
    >
      {/* Background Circle */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={thickness}
        sx={{
          color: bgColor,
          position: "absolute",
        }}
      />

      {/* Foreground Progress Circle */}
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        thickness={thickness}
        sx={{
          color: color,
        }}
      />

      {/* Center Text */}
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            color: color,
            fontWeight: 700,
            fontSize: size * 0.25, // auto-scale font with size
          }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressBar;
